import React from 'react';

import { DEFAULT_TABLE_CONTEXT, type TableContextType } from './types';

export const TableContext = React.createContext<TableContextType>(DEFAULT_TABLE_CONTEXT);
